import {PropertyHeaderQuery} from '../../../properties/models/property-header.model';
import {Exclude, Type} from 'class-transformer';
import {BaseListFilterWithSpecs, FilterModel, IdCodeNameQuery} from 'common-shared';
import {SpecLineFilterModel, SpecLineModel} from '../../../properties/models/spec-line.model';
import {SpecFilterOptions} from "common-shared";
import {FilterMetadata} from "primeng/api";

export class ItemQuery extends IdCodeNameQuery {
  ItemTypeClv: string;
  ItemGroupId: string;
  InventoryUnitId: string;
  @Type(() => PropertyHeaderQuery)
  PropertyHeader: PropertyHeaderQuery;
  StatusClv: string;
  AssignedTo: string;
  Comment: string;

  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'ItemTypeClv', 'ItemGroupId', 'InventoryUnitId', 'StatusClv'];
  }

  constructor(init?: Partial<ItemQuery>) {
    super();
    return Object.assign(this, init);
  }
}

export class ItemFilter extends ItemQuery {
  Specs: SpecLineFilterModel[] = [];
  SpecFilterOptions: SpecFilterOptions = new SpecFilterOptions;
  ItemGroupIds: string[] = [];
  ItemGroupTypes: string[] = [];
  ModifiedBy: string;
  @Exclude()
  ModifiedDateEqual: Date;
  @Exclude()
  ModifiedDateUnEqual: Date;
  AssignedTo: string;
  StatusClv: string;
  DatasetIds: string[] = [];
  WithoutValidResource: boolean;
  RouteDoesNotStartWithRawMaterial: boolean;

  constructor(init?: Partial<ItemFilter>) {
    super();
    this.Specs = [new SpecLineFilterModel()];
    return Object.assign(this, init);
  }
}

export class ItemListFilter extends BaseListFilterWithSpecs {
  ModifiedBy: FilterMetadata | FilterMetadata[];
  ModifiedDate: FilterMetadata | FilterMetadata[];
  AssignedTo: FilterMetadata | FilterMetadata[];
  InventoryUnitId: FilterMetadata | FilterMetadata[];
  TypeClv: FilterMetadata | FilterMetadata[];
  StatusClv: FilterMetadata | FilterMetadata[];
  OwnerClv: FilterMetadata | FilterMetadata[];
  ItemGroupId: FilterMetadata | FilterMetadata[];
  ToItemGroupId: FilterMetadata[];
  Specs: FilterMetadata | FilterMetadata[];
  GroupByDataset: boolean = false;

  constructor(init?: Partial<ItemListFilter>) {
    super();
    Object.assign(this, init);
  }
}

export class ItemBulkEditModel {
  Filter: FilterModel<ItemListFilter>;
  Rules: SpecLineModel[];

  constructor(itemListFilter: FilterModel<ItemListFilter>, editRules: SpecLineModel[]) {
    this.Filter = itemListFilter;
    this.Rules = editRules;
  }
}

export class ItemTableSelectableColumns {
  TypeClv = true;
  InventoryUnit = true;
  AssignedTo = true;
  StatusClv = true;
  ModifiedDate = true;
  ModifiedBy = true;
  InventoryMin = false;
  InventoryMax = false;
  PurchaseLotSizeMin = false;
  PurchaseLotSizeMax = false;
  ProductionLotSizeMin = false;
  ProductionLotSizeMax = false;
  OwnerClv = false;
  OperationSplitSizeMax = false;
}
